import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from 'react-router-dom';


const CardBuyByCategory = (props) => {


    return (

    	<span data-cro-id="hp-categories-icons" className="h-40 px-4">
            <Link className="flex flex-col items-center user-select-none w-full lg:p-0 lg:mx-0" to={props.data.url}>
                <div className="flex items-center justify-center" style={{width: '90px', height: '90px', lineHeight: 0}}>
                    <LazyLoadImage className="w-full h-full inline-block" src={props.data.megaMenu} width="90" height="90" alt={props.data.title} title="" style={{objectFit: 'contain'}} />
                </div>
                <p className="text-body2-strong text-neutral-900 mt-2 text-center ellipsis-2">{props.data.title}</p>
            </Link>
        </span>

    );
}

export default CardBuyByCategory;